// Front-end funnel tracking (Play 4). Fires the two client-originating funnel
// events — `visit` and `signup_started` — to the backend's public
// `/v1/analytics/track`. Everything else in the funnel (signup_completed, paid,
// task success, ...) is emitted server-side from the authoritative handlers, so
// it can't be spoofed from the browser.
//
// Best-effort by design: a tracking failure must never affect the UI, so every
// call is fire-and-forget and errors are swallowed.

const ANON_ID_KEY = "lin.anonId";

function getAnonId(): string {
  try {
    let id = localStorage.getItem(ANON_ID_KEY);
    if (!id) {
      id = `anon_${crypto.randomUUID()}`;
      localStorage.setItem(ANON_ID_KEY, id);
    }
    return id;
  } catch {
    // Private mode / storage disabled: fall back to an ephemeral id.
    return `anon_ephemeral`;
  }
}

export type ClientFunnelEvent = "visit" | "signup_started";

export function trackEvent(
  baseUrl: string,
  event: ClientFunnelEvent,
  props?: Record<string, unknown>
): void {
  try {
    void fetch(`${baseUrl}/v1/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, anonId: getAnonId(), props }),
      keepalive: true
    }).catch(() => {
      /* best-effort */
    });
  } catch {
    /* best-effort */
  }
}
